import { useEffect, useState } from "react";
import useLeagueBySlug from "@/hooks/useLeagueBySlug";
import { useCompConfig } from "@/context/CompConfigContext";
import { buildThemeConfig } from "@/components/LichThiDauFull/buildThemeConfig";
import { fetchLtdMatchesForLeague } from "./leagueFixturesByLeagueActions";

export default function useLichThiDauByLeague(leagueSlug) {
  const compConfig = useCompConfig();
  const themeStyle = buildThemeConfig(compConfig, compConfig.hasDataConfig);
  const [activeSlug, setActiveSlug] = useState(leagueSlug || "");
  const { league, loading: leagueLoading } = useLeagueBySlug(activeSlug);
  const leagueId = league?.id;
  const currentRound = league?.currentRound;
  const [initialMatchesEntries, setInitialMatchesEntries] = useState(null);
  const [initialLoading, setInitialLoading] = useState(!!activeSlug);

  useEffect(() => {
    setActiveSlug(leagueSlug || "");
  }, [leagueSlug]);

  useEffect(() => {
    if (!leagueId) {
      setInitialMatchesEntries(null);
      return undefined;
    }
    let cancelled = false;
    setInitialMatchesEntries(null);
    setInitialLoading(true);
    (async () => {
      const entries = await fetchLtdMatchesForLeague({ id: leagueId, currentRound });
      if (cancelled) return;
      setInitialMatchesEntries(Array.isArray(entries) ? entries : []);
      setInitialLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [leagueId, currentRound]);

  const waiting = !!activeSlug && (leagueLoading || initialLoading || !initialMatchesEntries);
  const failed = !!activeSlug && !leagueLoading && !league;

  return {
    themeStyle,
    activeSlug,
    setActiveSlug,
    league,
    leagueLoading,
    initialMatchesEntries,
    waiting,
    failed,
  };
}
